module.exports = __webpack_public_path__ + "img/header_bg.1ed38cb4.png";